import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-5498c5a9"), n = n(), _popScopeId(), n);

const _hoisted_1 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "big-title"
}, "关于我们-甜心公园APP", -1));

const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "content"
}, [/*#__PURE__*/_createTextVNode(" 甜心公园APP是海南金钱豹科技有限公司倾力打造的一款高品质社交平台，致力于为用户创造真实、真诚、安全、有趣的社交体验。"), /*#__PURE__*/_createElementVNode("br"), /*#__PURE__*/_createTextVNode(" 我们通过多维度认证体系严格把关，以智能算法精准匹配，让每一次邂逅都充满惊喜。在这里，趣味互动玩法持续点燃心动火花，专业安全守护全程陪伴，助您遇见那个真正对的人，开启浪漫美好的社交之旅。"), /*#__PURE__*/_createElementVNode("br"), /*#__PURE__*/_createTextVNode(" 核心功能真人认证，通过AI智能识别+人工审核的机制，保障用户照片真实。")], -1));

const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "content"
}, "联系我们：tianxinkefu@163.com ", -1));

const _hoisted_4 = [_hoisted_1, _hoisted_2, _hoisted_3];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock(_Fragment, null, [_withDirectives(_createElementVNode("div", {
    class: "hello",
    onClick: _cache[0] || (_cache[0] = //@ts-ignore
    (...args) => $setup.hideTip && $setup.hideTip(...args))
  }, _hoisted_4, 512), [[_vShow, $setup.show]]), _withDirectives(_createElementVNode("div", {
    class: "back",
    onClick: _cache[1] || (_cache[1] = //@ts-ignore
    (...args) => $setup.hideTip && $setup.hideTip(...args))
  }, null, 512), [[_vShow, $setup.show]])], 64);
}